import { useState } from "react";
import styled from "styled-components";
import FeedbackIcon from "@mui/icons-material/FeedbackOutlined";
import { SideDialog } from "@clatter/ui";
import { FeedbackForm } from "./FeedbackForm";

const TabWrapper = styled.div`
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
`;

const TabButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  border: none;
  background: ${({ theme }) => theme?.palette?.white ?? "#fff"};
  box-shadow: -2px 2px 10px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  padding: 14px 10px;
  border-radius: 8px 0 0 8px;
  font-size: ${({ theme }) => theme?.fontSize?.body ?? "0.8125rem"};
  font-weight: 700;
  font-family: ${({ theme }) => theme?.fontFamily?.main ?? "inherit"};
  color: ${({ theme }) => theme?.palette?.text ?? "#181A30"};

  svg {
    font-size: 17px;
    flex-shrink: 0;
  }

  &:hover {
    background: ${({ theme }) => theme?.palette?.iconButtonHoverBackground ?? "#f2f2f4"};
  }
`;

const TabLabel = styled.span`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
`;

export function FeedbackWidget() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TabWrapper>
        <TabButton type="button" onClick={() => setOpen(true)}>
          <FeedbackIcon />
          <TabLabel>Feedback</TabLabel>
        </TabButton>
      </TabWrapper>

      <SideDialog isOpen={open} onClose={() => setOpen(false)} hideCloseButton width="35vw" padding="0px" maxWidth="500px">
        <FeedbackForm onClose={() => setOpen(false)} />
      </SideDialog>
    </>
  );
}
